// PURPOSE: Download authorized invoice artifacts. CONTRACT: authenticated fetch and visible errors precede browser save. DEPENDS: native document endpoints. CEILING: no posting, sending or unauthenticated links.
import { useState } from 'react';
import { Download } from 'lucide-react';
import { useSession } from './auth';
import { ErrorNotice } from './components';

export function InvoiceDocuments({ id }: { id: string }) {
  const { api } = useSession();
  const [pending, setPending] = useState<'pdf' | 'html' | null>(null);
  const [error, setError] = useState<unknown>();
  const [message, setMessage] = useState('');
  async function download(format: 'pdf' | 'html') {
    if (pending) return;
    setPending(format); setError(undefined); setMessage('');
    try {
      const blob = await api.invoiceDocument(id, format);
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url; anchor.download = `invoice-${id.replace(/[^a-zA-Z0-9_-]/g, '')}.${format}`;
      document.body.append(anchor); anchor.click(); anchor.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
      setMessage(`${format === 'pdf' ? 'PDF' : 'Printable HTML'} download started.`);
    } catch (failure) { setError(failure); }
    finally { setPending(null); }
  }
  return <section className="panel" aria-label="Invoice documents"><div className="panel-heading"><div><h2>Invoice documents</h2><p>Download the saved invoice with its current recorded receipts and balance. Drafts are clearly marked.</p></div></div><div className="inline-actions"><button className="button secondary" disabled={!!pending} onClick={() => download('pdf')}><Download size={16} />{pending === 'pdf' ? 'Preparing PDF…' : 'Download PDF'}</button><button className="button quiet" disabled={!!pending} onClick={() => download('html')}>{pending === 'html' ? 'Preparing HTML…' : 'Download printable HTML'}</button></div>{error !== undefined && <ErrorNotice error={error} />}{message && <p className="small" role="status">{message}</p>}</section>;
}
